import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const QuestionIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 17, height = 16, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M5.83325 5.33334C5.83325 4.80291 6.07908 4.2942 6.51667 3.91913C6.95425 3.54406 7.54775 3.33334 8.16659 3.33334H8.83325C9.45209 3.33334 10.0456 3.54406 10.4832 3.91913C10.9208 4.2942 11.1666 4.80291 11.1666 5.33334C11.1911 5.76618 11.0744 6.19527 10.8339 6.55599C10.5934 6.91671 10.2422 7.18953 9.83325 7.33334C9.42427 7.5251 9.07309 7.88885 8.83261 8.36981C8.59213 8.85077 8.47537 9.42289 8.49992 10M8.49992 12.6667V12.6733"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
